// api/services/broadcasters.ts
import { handleRequest } from '@/api';
import type { Broadcaster } from '@/types';

interface FetchOpts {
    signal?: AbortSignal;
}

interface BroadcasterPayload {
    broadcaster_name: string;
    country_code: string;
    country_list?: string[];
    currency_code?: string;
}

interface BroadcasterUpdatePayload extends BroadcasterPayload {
    id: number;
}

interface BroadcasterOperationResponse {
    message: string;
    broadcaster_id: number;
}

export const getBroadcasters = (opts: FetchOpts = {}): Promise<Broadcaster[]> =>
    handleRequest<Broadcaster[]>('get', '/broadcasters/', opts);

export const createBroadcaster = (broadcasterData: BroadcasterPayload): Promise<BroadcasterOperationResponse> =>
    handleRequest<BroadcasterOperationResponse>(
        'post',
        '/broadcasters/',
        broadcasterData,
        'Broadcaster created successfully!'
    );

export const updateBroadcaster = (payload: BroadcasterUpdatePayload): Promise<BroadcasterOperationResponse> =>
    handleRequest<BroadcasterOperationResponse>(
        'put',
        `/broadcasters/${payload.id}`,
        payload,
        'Broadcaster updated successfully'
    );
